import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';

import ReactButton from 'components/Buttons/ReactButton';

function RecordTypeSelection({
  recordTypes = [],
  handleOnSelectedRecordType,
  showConfirmationButton = true
}) {
  const { handleSubmit } = useForm();
  const [selectedRecordType, setSelectedRecordType] = useState(null);

  useEffect(() => {
    if (recordTypes && recordTypes.length) {
      setSelectedRecordType(recordTypes[0].id);
    }
  }, [recordTypes]);

  const onSelectionChange = (event) => {
    const value = event.target.value;
    setSelectedRecordType(value);
    handleOnSelectedRecordType(value);
  };

  const onSubmit = () => {
    if (!selectedRecordType) return;
    handleOnSelectedRecordType(selectedRecordType);
  };

  return (
    <>
      <h1 className="mb-0 pb-0">Tipos de registro</h1>
      <h2 style={{ fontSize: '0.8rem', marginBottom: '0.6rem' }}>
        Selecione algum dos tipos de registro abaixo
      </h2>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col sm="12">
            <FormGroup tag="fieldset">
              {recordTypes &&
                recordTypes.map((recordType, index) => (
                  <FormGroup check key={recordType.id}>
                    <Label check>
                      <Input
                        type="radio"
                        name="selectedRecordType"
                        value={recordType.id}
                        defaultChecked={index === 0}
                        onChange={onSelectionChange}
                      />{' '}
                      {recordType.name}
                    </Label>
                  </FormGroup>
                ))}
            </FormGroup>
          </Col>
        </Row>
        {!!showConfirmationButton && (
          <Row>
            <Col sm="12" className="mt-3">
              <ReactButton btnColor="confirmation" type="submit">
                Confirmar
              </ReactButton>
            </Col>
          </Row>
        )}
      </Form>
    </>
  );
}

export default RecordTypeSelection;
